import { Box, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useState } from 'react';

import BottomNav from '@/components/BottomNav';
import CallToAction from '@/components/CallToAction';
import EventInfo from '@/components/EventInfo';
import { LoadingSpinner } from '@/components/Loading';
import SponsorList from '@/components/SponsorList';
import TicketCards from '@/components/TicketCards';
import { useEvent } from '@/contexts/EventsContext';
import { createApi } from '@/utils/api';

/** @param {import("prop-types").InferProps<typeof HomePropTypes>} props */
export default function Home({ sponsors }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isLoading, setIsLoading] = useState(true);
  const { active /* , areDonationsOpen */ } = useEvent();

  if (isLoading) return <LoadingSpinner setIsLoading={setIsLoading} />;

  return (
    <Box sx={{ paddingBottom: 2 }}>
      <Head>
        <title>Home | NoReset</title>
        <meta content="Home | NoReset" name="description" />
      </Head>
      <Grid container>
        <Grid size={{ xl: active ? 9 : 12, xs: 12 }}>
          <CallToAction activeEvent={active} />
        </Grid>
        {active && (
          <Grid size={{ xl: 3, xs: 12 }}>
            <EventInfo activeEvent={active} />
          </Grid>
        )}
        <Container maxWidth="xl">
          {active && (
            <Grid size={12}>
              <TicketCards activeEvent={active} />
            </Grid>
          )}
          <Grid size={12}>
            <SponsorList sponsors={sponsors} />
          </Grid>
          {/* <Grid size={12}>
            <DonationList eventId={active?.id} limit={5} />
          </Grid> */}
        </Container>
      </Grid>
      {isMobile && <BottomNav />}
    </Box>
  );
}

const HomePropTypes = {
  sponsors: PropTypes.arrayOf(PropTypes.object).isRequired,
};
Home.propTypes = HomePropTypes;

/** @type  {import("next").GetServerSideProps<import("prop-types").InferProps<typeof HomePropTypes>>} */
export async function getServerSideProps({ req }) {
  const api = createApi(req.headers);
  const response = await api.get('/api/v2/sponsors/');

  return { props: { sponsors: response.data.filter(sponsor => sponsor.isActive) } };
}
